// app/windows/ReglementContent.tsx
export function ReglementContent() {
  return (
    <>
      <p className="mt-1 font-bold font-stretch-condensed">
        1. RÉGLEMENTS 
      </p>
      <p className="mt-2 text-justify font-stretch-condensed"> 
      Voici les règlements de la 3e édition de la compétition. Dans
      l’éventualité qu’un problème majeur soit découvert, ces règlements
      sont sujets à modification à tout moment. En cas de doute, vous êtes
      invités à vérifier avec les organisateurs. Tout non-respect de ces
      règlements peut mener à une disqualification.
      </p>
      <p className="mt-3 font-bold text-justify font-stretch-condensed"> 
        1.1 CONSTRUCTION DES ROBOTS:
      </p>
        <ul className="mt-1 list-disc list-inside font-normal font-stretch-condensed">
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Le poids maximale autorisé pour un robot est de 600 grammes.
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Les dimensions maximales autorisées sont 15x15x15 cm.
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Un robot ne peut dépasser ces dimensions que lorsque le combat est débuté.
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Un robot ne doit pas coûter plus de 200$.
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Une source d’alimentation ne doit pas excéder 16.8V(4S).
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Un robot doit être équipé d’un fusible approprié pour sa source d’alimentation.
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Un robot doit être équipé d’un voyant lumineux pour indiquer qu’il est alimenté. 
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Un robot ne doit rien laisser tomber intentionnellement dans l’arène ou sur le robot adverse (ex. : colle, huile, etc.) 
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Aucune arme destructrice n’est permise (ex. : lame, lance-flamme, etc.)
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Aucun robot volant n’est permis
          </li>
          <li className="opacity-80  list-disc list-inside font-normal font-stretch-condensed">
          Aucune nuisance au bon contrôle du robot adverse par son
          pilote n’est permise (ex : brouillage de signal, lumière
          obstruant la vue du pilote, etc.)          
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Aucun adhésif n’est permis pour se coller à l’arène ou au robot adverse          
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
          Si, par accident, lors d’une collision, un morceau d’un robot
          se détache, personne ne sera pénalisé au verdict des juges
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Il est permis pour un robot d’avoir un équipement pour
            pousser, renverser ou déplacer le robot adverse
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Chaque robot sera vérifié par un organisateur pour assurer
            le respect des règlements ci-présent.
          </li>
        </ul>
      <p className="mt-3 font-bold  font-stretch-condensed">
        1.2 REGLEMENTS GÉNÉRAUX: 
      </p>
        <ul className="mt-1 list-disc list-inside font-normal font-stretch-condensed">
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Les pilotes doivent respecter les consignes des
            organisateurs en toute circonstance.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un seul pilote est autorisé à contrôler le robot à la fois par
            équipe pour chaque équipe.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Chaque partie dure un maximum de 3 minutes.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Si aucun gagnant n’est déterminé dans les 3 minutes
            allouées, le match sera jugé sur la performance de chaque
            robot par les juges.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un pilote peut abandonner la partie en tout temps.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Si le contrôle d’un robot est perdu, le pilote a 10 secondes
            pour regagner le contrôle de son robot et se déplacer, faute
            de quoi il perd la partie.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un robot peut épingler son adversaire pour un maximum de
            20 secondes. Les juges donneront un avertissement à
            15 secondes. Si à la fin des 20 secondes, aucun robot ne
            bouge, la partie sera mise sur pause et les robots
            recommenceront à leur position initiale.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Si deux robots tombent en dehors de l’arène au même
            moment, la partie sera mise sur pause et les robots
            retourneront à leur emplacement initial.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un robot n’est pas considéré en dehors de l’arène si une
            partie contrôlable et mobile du robot demeure dans l’arène.
        </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Après l’appel des organisateurs pour rassembler les
            équipes, les pilotes ont 5 minutes pour s’installer et
            commencer la partie, faute de quoi ils perdent la partie.
        </li>
        </ul>
      <p className="mt-3 font-bold font-stretch-condensed">
        1.3 CONDITIONS DE VICTOIRE:
      </p>
        <ul className="">
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un robot est victorieux s’il sort son adversaire en dehors de
            l’arène.
          </li>
          <li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un robot est victorieux s’il renverse le robot adverse dans
            une position immobile pendant 10 secondes.
          </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un robot remporte le choix des juges. (Originalité,
            Présentation, Concept).
          </li><li className="opacity-80 list-disc list-inside font-normal font-stretch-condensed">
            Un robot remporte le coup de cœur du public.
          </li>
        </ul>
      <p className="">
      </p>

    </>
  );
}
